export const payrollCategories = [
    "W-2 Employee",
    "1099 Independent Contractor",
    "Perm Placement Only",
];

export const regularRadioAnswer = [
    {
        label: "Yes",
        value: true,
    },
    {
        label: "No",
        value: false,
    },
];

export const smallBusinessCategories = [
    "Minority Owned Business",
    "Woman Owned Business",
    "Veteran Owned Business",
    "HUB Business",
    "Disadvantaged Business Enterprise",
    "Maryland DOT MBE Certified",
    "Other",
];

export const poolRoles = [
    "Nursing",
    "Allied",
    "Pharmacy",
    "Interim Leadership",
    "Locums",
    "Non-Clinical",
];

export const nursingPoolRoles = [
    "Long Term Care",
    "Acute Care",
    "Schools",
    "Corrections",
    "Other",
];

export const discoverySources = ["Google", "Client", "Friend", "Other"];

export const validationInputs = [
    "company_name",
    "company_address",
    "city",
    "state",
    "zip_code",
    "company_website",
    "company_email",
    "company_phone",
    "company_operation_years",
    "company_healthcare_staffing_years",
    "payroll_category",
    "beneficial_owners",
    "has_eor",
    "has_peo",
    "has_back_office_organization",
    "excluded_by_careerstaff",
    "excluded_by_oig",
    "is_small_business",
    "staffs_locally",
    "staffs_travel",
    "staffs_per_diem",
    "staffs_contracts",
    "active_healthcare_pool_states",
    "candidate_pool_roles",
    "signature",
    "date",
    "name",
    "title",
    "phone",
    "email",
];

export const deleteUnusedFields = data => {
    if (!data["has_eor"]) {
        delete data["eor"];
        delete data["eor_contact_name"];
        delete data["eor_phone"];
        delete data["eor_email"];
    }

    if (!data["has_peo"]) {
        delete data["peo"];
        delete data["peo_contact_name"];
        delete data["peo_phone"];
        delete data["peo_email"];
        delete data["peo_w2_employer_company"];
    }

    if (!data["has_back_office_organization"]) {
        delete data["back_office_other"];
        delete data["back_office_contact_name"];
        delete data["back_office_phone"];
        delete data["back_office_email"];
    }

    if (!data["excluded_by_careerstaff"]) {
        delete data["excluded_by_careerstaff_explanation"];
    }

    if (!data["excluded_by_oig"]) {
        delete data["excluded_by_oig_explanation"];
    }

    if (!data["is_small_business"]) {
        delete data["small_business_categories"];
    }

    if (!data["staffs_locally"]) {
        delete data["local_staff_states"];
    }

    if (!data["staffs_travel"]) {
        delete data["travel_staff_states"];
    }

    if (!data["staffs_per_diem"]) {
        delete data["staffs_per_diem_states"];
    }

    if (!data["staffs_contracts"]) {
        delete data["staffs_contracts_states"];
    }

    if (!data["candidate_pool_roles"]?.includes("Nursing")) {
        delete data["nursing_pool_roles"];
    }

    if (!data["careerstaff_discovery_sources"]?.includes("Other")) {
        delete data["other_discovery_source"];
    }
};
